module.exports = __webpack_public_path__ + "static/img/c08dd722ef5654ca540e6621ba0dd7d4.73ad500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c08dd722ef5654ca540e6621ba0dd7d4.jpg
// module id = pnH1
// module chunks = 4